export default {
    apiBaseUrl: 'https://api.albertmagazin.de'
}
